interface Props {
  isAffiliate?: boolean;
}

export default function StepComplete({ isAffiliate = false }: Props) {
  return (
    <div style={{ textAlign: 'center', padding: '10px 0' }}>
      <div
        style={{
          width: '70px',
          height: '70px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #fa7c9e, #ff5c73)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
        }}
      >
        <i className="ri-check-line" style={{ color: 'white', fontSize: '32px' }} />
      </div>

      <h3
        style={{
          fontWeight: 900,
          fontSize: '18px',
          color: '#ff5c73',
          marginBottom: '16px',
          lineHeight: 1.4,
        }}
      >
        {isAffiliate ? '登録ありがとうございました！' : 'ご回答ありがとうございました！'}
      </h3>

      <p style={{ fontSize: '14px', color: '#555', lineHeight: 1.9, marginBottom: '20px' }}>
        1営業日以内に専属アドバイザーより<br />
        ご登録いただいた電話番号にご連絡いたします。<br />
        <br />
        <span style={{ fontSize: '13px', color: '#888' }}>
          ※非通知・番号非表示からのお電話の場合、<br />
          折り返しができない場合がございます。
        </span>
      </p>
    </div>
  );
}